import AOS from 'aos';
import 'aos/dist/aos.css';

/**
 * TODO:
 *  1. to be extended to account for any iframe number of iframes on the page,
 *  2 cleanup console
 *  3 confirm browser support for "ResizeObserver"
 */

const useAos = false;

if (!/Android|iPhone/i.test(navigator.userAgent) && useAos) {
    const aosDataPromise = new Promise((resolve, reject) => {
        const entryContent = document.querySelector('.entry-content');
        for (let i = 0; i < entryContent.children.length; i++) {
            entryContent.children[i].setAttribute('data-aos', 'fade-up');
        }
        entryContent.children[entryContent.children.length] = entryContent.children[entryContent.children.length - 1];
        resolve(true);
        reject('failed to set data-aos attribute');
    });

    aosDataPromise.then(() => {

    }).catch((e) => {
        console.warn(e);
    }).finally(() => {
        AOS.init({
            disable: 'mobile',
            offset: 100, // offset (in px) from the original trigger point
            delay: 300, // values from 0 to 3000, with step 50ms
            duration: 250, // values from 0 to 3000, with step 50ms
            easing: 'ease-in-out', // default easing for AOS animations
            anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger
                                           // the// animation
        });
        window.dispatchEvent(new Event('resize'));
    });


    let textBox = document.querySelector('.carsale-widget');
    let previousHeight = textBox?.offsetHeight;

    const resizeFunc = function () {
        const { offsetHeight } = textBox;

        if (Math.abs(offsetHeight - previousHeight) > 1000) {
            previousHeight = offsetHeight;
            AOS?.refresh();
            // setTimeout(() => window.dispatchEvent(new Event('resize')), 300);
        }
    };

    if (textBox) {
        new ResizeObserver(resizeFunc).observe(textBox);
        window.addEventListener('load', () => {
            new ResizeObserver(resizeFunc).observe(textBox);
        });
    }

}




